import { cn } from "../../../../utils/cn";
import { PaidReceipt } from "../../../../utils/types";
import { LocationIconFilled } from "../PayScreen.icons";
import {
  ReceiptStateCompletedIcon,
  ReceiptStateDeliveryIcon,
  ReceiptStatePendingIcon,
  ReceiptStatePreparingIcon,
} from "./ReceiptState.icons";
import styles from "./ReceiptState.module.scss";
import { useDeliveryReceiptState } from "./useDeliveryReceiptState";

export const DeliveryReceiptStateV2 = (props: {
  isOrdersTab?: boolean;
  receipt: PaidReceipt;
}) => {
  const { isOrdersTab = false, receipt } = props;

  const {
    addressTo,
    showDeliveryAddress,
    deliveryAddressText,
    pendingText,
    secondStepLabel,
    secondStepActive,
    thirdStepActive,
    fourthStepActive,
    onItsWay,
    delivered,
    isCancelled,
  } = useDeliveryReceiptState({ isOrdersTab, receipt });

  return (
    <div
      className={`${styles.receipt_status} ${
        isOrdersTab ? styles.is_orders_tab : ""
      }`}
    >
      {showDeliveryAddress && isOrdersTab && (
        <p
          data-testid="delivery-to-address"
          className={styles.delivery_section}
        >
          {isOrdersTab && (
            <>
              {addressTo}
              <span>
                <LocationIconFilled />
                {deliveryAddressText}
              </span>
            </>
          )}
        </p>
      )}
      {!isCancelled && (
        <div className={styles.state_wrapper_v2}>
          <div
            className={cn(
              styles.state_wrapper_v2__line,
              styles["state_wrapper_v2__line--leading"],
              styles.compact,
              styles.active
            )}
          />
          <div className={`${styles.state_wrapper_v2__state} ${styles.active}`}>
            <span className={styles.state_wrapper_v2__state__icon}>
              <ReceiptStatePendingIcon size={19.5} />
            </span>
            <span
              data-testid="recieved-state"
              className={styles.state_wrapper_v2__state__text}
            >
              {pendingText}
            </span>
          </div>
          <div
            className={`${styles.state_wrapper_v2__line}${
              secondStepActive ? ` ${styles.active}` : ""
            }`}
          />
          <div
            className={`${styles.state_wrapper_v2__state}${
              secondStepActive ? ` ${styles.active}` : ""
            }`}
          >
            <span className={styles.state_wrapper_v2__state__icon}>
              <ReceiptStatePreparingIcon width={24} height={16} />
            </span>
            <span
              data-testid="confirmed-state"
              className={styles.state_wrapper_v2__state__text}
            >
              {secondStepLabel}
            </span>
          </div>
          <div
            className={`${styles.state_wrapper_v2__line}${
              thirdStepActive ? ` ${styles.active}` : ""
            }`}
          />
          <div
            className={`${styles.state_wrapper_v2__state}${
              thirdStepActive ? ` ${styles.active}` : ""
            }`}
          >
            <span className={styles.state_wrapper_v2__state__icon}>
              <ReceiptStateDeliveryIcon size={24} />
            </span>
            <span className={styles.state_wrapper_v2__state__text}>
              {onItsWay}
            </span>
          </div>
          <div
            className={`${styles.state_wrapper_v2__line}${
              fourthStepActive ? ` ${styles.active}` : ""
            }`}
          />
          <div
            className={`${styles.state_wrapper_v2__state}${
              fourthStepActive ? ` ${styles.active}` : ""
            }`}
          >
            <span className={styles.state_wrapper_v2__state__icon}>
              <ReceiptStateCompletedIcon size={21} />
            </span>
            <span className={styles.state_wrapper_v2__state__text}>
              {delivered}
            </span>
          </div>
          <div
            className={cn(
              styles.state_wrapper_v2__line,
              styles["state_wrapper_v2__line--trailing"],
              styles.compact,
              styles.fourthStepActive && styles.active
            )}
          />
        </div>
      )}
    </div>
  );
};
